// 配置表格 https://docs.google.com/spreadsheets/d/11YzMN4ANW0mZRs9yC_YTOma-ef9EVa-fsgUNd2MpImc/edit#gid=2071571245
const config = {
  // 注册	点击注册完成按钮上报
  register: {
    eventName: "CompleteRegistration",
    eventProperties: {
      adjust_id: "adid",
      uid: null,
    },
  },
  // 商详访问 用户进入商品详情页
  productDetail: {
    eventName: "ViewContent",
    eventProperties: {
      content_type: "product",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
    },
  },
  // 订单创建	用户创建实体订单并且确认提交,当点击“创建“按钮时上报,
  createOrder: {
    eventName: "InitiateCheckout",
    eventProperties: {
      content_type: "product",
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      num_items: "商品数量",
    },
  },
  // 添加支付信息	用户提交完订单后进入收银台的支付详情页，选择支付方式时上报  点击“pay now” 按钮上报
  payNow: {
    eventName: "AddPaymentInfo",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
    },
  },
  // 分享	用户点击分享方式按钮上报
  productDetailShare: {
    eventName: "Subscribe",
    eventProperties: {
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
    },
  },
  // 支付结果	支付结果页上报(不论结果成功or失败)
  payResult: {
    eventName: "Purchase",
    eventProperties: {
      content_type: "product",
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      num_items: "商品数量",
    },
  },
  // 支付成功（真支付成功）	后端返回支付成功结果上报
  paySuccess: {
    eventName: "purchase_real",
    eventProperties: {
      content_type: "product",
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      num_items: "商品数量",
    },
  },
  // 填写个人资料	kyc填写资料页上报
  kycInfoSave: {
    eventName: "SubmitApplication",
    eventProperties: {},
  },
  // 每次登录成功上报	每次登陆均上报
  login: {
    eventName: "login",
    eventProperties: {},
  },
  // 分期下单	支付结果页上报
  installmentOrder: {
    eventName: "Search",
    eventProperties: {
      content_ids: "sku_id(所有sku_id一起上报), 例: ['abc123', 'xyz789']",
      currency: "币种(欧洲:EUR)",
      value: "商品售价,",
      num_items: "商品数量",
    },
  },
};

export type FbPXConfigKey = keyof typeof config;

export default config;
